import Headroom from 'headroom.js';

let headroom;

const initHeadroom = function(element, onUnpinCallback, onPinCallback) {
    // construct an instance of Headroom, passing the element
    headroom  = new Headroom(element, {
        "offset": 205,
        "tolerance": {
            up : 30,
            down : 0
        },
        onUnpin: onUnpinCallback,
        onPin: onPinCallback,
    });

    // initialise
    headroom.init();
    if (document.documentElement.scrollTop > 400) {
        headroom.unpin();
    }

    return headroom;
}

export { headroom, initHeadroom };


// WEBPACK FOOTER //
// ./resources/assets/js/used-vue/api/InitHeadroom.js